module.exports = __webpack_public_path__ + "img/Profile View - 2.e127fff8.svg";